export const ALL = 'ALL';
export const WHOLE_REQUEST = 'WHOLE_REQUEST';
